﻿import { createFileRoute } from "@tanstack/react-router";
import { ListaComprasPage } from "@/paginas/pg_franquia/franquia-compras-listas";

export const Route = createFileRoute("/_authenticated/compras-listas")({
  head: () => ({
    meta: [
      { title: "Listas de compras — Milky Moo Palmares" },
      {
        name: "description",
        content: "Listas de compras da sorveteria, com histórico e impressão.",
      },
      { property: "og:title", content: "Listas de compras — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Listas de compras da sorveteria, com histórico e impressão.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ListaComprasPage,
});
